const darkBlue = {
  main: "#1462a1",
  light: "#1462a1",
  dark: "#1462a1",
};

export { darkBlue };
